import { http, upload } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-列表
 */
export function API_JT_PROJ_LIST(data?: BasicPageReq) {
  return http.post<ApiJtProj.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-全部
 */
export function API_JT_PROJ_ALL(data?: BasicPageReq) {
  return http.post<ApiJtProj.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-简单列表
 */
export function API_JT_PROJ_SIMPLE_LIST(data?: BasicPageReq) {
  return http.post<BasicSimpleListItem[]>(URL.SIMPLE_LIST, data)
}

/**
 * 集体土地项目-详情
 */
export function API_JT_PROJ_DETAIL(id: string, householdId?: string) {
  return http.post<ApiJtProj.Item>(URL.DETAIL, { id, householdId })
}

/**
 * 集体土地项目-新增
 */
export function API_JT_PROJ_ADD(data: ApiJtProj.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-删除
 */
export function API_JT_PROJ_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-编辑
 */
export function API_JT_PROJ_EDIT(data: BasicUpdateOneReq<ApiJtProj.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-禁用
 */
export function API_JT_PROJ_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-启用
 */
export function API_JT_PROJ_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-排序
 */
export function API_JT_PROJ_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-导出
 */
export function API_JT_PROJ_EXPORT(data: BasicExportReq) {
  return http.post(URL.EXPORT, data)
}

/**
 * 集体土地项目-统计
 */
export function API_JT_PROJ_TONGJI(data: IdsPayload) {
  return http.post(URL.TONGJI, data)
}

/**
 * 集体土地项目-项目进度设置
 */
export function API_JT_PROJ_PROCESS_SET(data: BasicUpdateOneReq<ApiJtProj.ProcessData>) {
  return http.post(URL.PROCESS_SET, data)
}

/**
 * 集体土地项目-拆迁补偿标准设置
 */
export function API_JT_PROJ_COMP_STANDARD_SET(data: BasicUpdateOneReq<ApiJtProj.CompStandardData>) {
  return http.post(URL.COMP_STANDARD_SET, data)
}

/**
 * 集体土地项目-录入-列表
 */
export function API_JT_PROJ_DATA_LIST(data?: BasicPageReq) {
  return http.post<ApiJtProj.ListRes>(URL.DATA_LIST, data)
}

/**
 * 集体土地项目-全部详情
 */
export function API_JT_PROJ_ALL_DETAIL(id: string) {
  return http.post<ApiJtProj.Item>(URL.ALL_DETAIL, { id })
}

/**
 * 集体土地项目-获取项目下的村庄列表
 */
export function API_JT_PROJ_VILLAGE_LIST(id: string) {
  return http.post<string[]>(URL.VILLAGE_LIST, { id })
}

/**
 * 集体土地项目-绑定房源
 */
export function API_JT_PROJ_HOUSE_BIND(data: ApiJtProj.HouseBindReq) {
  return http.post(URL.HOUSE_BIND, data)
}

/**
 * 集体土地项目-获取绑定的房源列表
 */
export function API_JT_PROJ_HOUSE_LIST(id: string) {
  return http.post<ApiHouse.Item[]>(URL.HOUSE_LIST, { id })
}

/**
 * 集体土地项目-社保导入模板下载
 */
export function API_JT_PROJ_SS_TPL() {
  return http.post(URL.SS_TPL)
}

/**
 * 集体土地项目-社保导入
 */
export function API_JT_PROJ_SS_IMPORT(file: File, projectId: string) {
  return upload(URL.SS_IMPORT, { file, data: { projectId } })
}

/**
 * 集体土地项目-社保导入记录列表
 */
export function API_JT_PROJ_SS_RECORD_LIST(data?: BasicPageReq) {
  return http.post(URL.SS_RECORD_LIST, data)
}

/**
 * 集体土地项目-社保导入记录恢复
 */
export function API_JT_PROJ_SS_RECORD_RECOVER(shebaoId: string) {
  return http.post(URL.SS_RECORD_RECOVER, { shebaoId })
}

/**
 * 集体土地项目-获取安置标准详情
 */
export function API_JT_PROJ_RESETTLE_STANDARD_DETAIL(projectId: string) {
  return http.post<ApiJtProj.ResettleStandardItem[]>(URL.RESETTLE_STANDARD_DETAIL, { projectId })
}

/**
 * 集体土地项目-保存安置标准详情
 */
export function API_JT_PROJ_RESETTLE_STANDARD_SAVE(data: ApiJtProj.ResettleStandardSaveReq) {
  return http.post(URL.RESETTLE_STANDARD_SAVE, data)
}
